"use strict";

import EventEmitter from 'eventemitter2';
import Browser from '../util/browser'
import BtnHamburger from '../btn/btnhumberger';
import BtnPageTop from '../btn/btnpagetop';
import BtnSpot from '../btn/btnspot';
import BtnMovie from '../btn/btnmovie';
import DecoCircle from '../parts/decocircle';
import Youtube from '../parts/youtube';


import Header from '../section/header';
import Gnav from '../section/gnav';

class Zoomin extends EventEmitter{
	constructor(){
		super();
	}
	
	init(){
		createjs.Ticker.init();
		createjs.Ticker.setFPS(60);
		createjs.Ticker.addEventListener('tick',createjs.Tween);
		
		//Header
		//this.header = new Header( $('#Header') );

		//Gnav
		this.gnav = new Gnav( $('#Gnav') );
				
		//BtnHamburger
		this.btnHamburger = new BtnHamburger( $('#BtnHamburger') );
		
		//PageTop
		this.btnPageTop = new BtnPageTop( $('#BtnPageTop') );
		
		
		//BtnSpot
		//this.btnSpot = new BtnSpot( $('#BtnSpot') );
		
		//DecoCircle
		$('.DecoCircle').each((i,v)=>{
			$(v).data('decocircle' , new DecoCircle( $(v) ) );
		})
		
		//BtnMovie
		$('.BtnMovie').each((i,v)=>{
			$(v).data('btnmovie' , new BtnMovie( $(v) ) );
		})
		
		this.emit('init1');
	}
	
	init2(){
		
		//SCROLL MAGIC
		this.scrollMagicWrapper = new ScrollMagicWrapper(this);

		//Youtube
		Youtube.initYoutube();
		
		this.initEvent();
		
		this.emit('init2');	
	}
	
	start(){
		this.initScPosition();
		//this.header.start();
	}

	initTab(){
/*
		var hash = location.hash;
		var id;
		if(hash == '#Sanpo'){
			id = 'TabSanpo';
		} else if(hash == '#Zoom'){
			id = 'TabZoom';
		}
		
		let $TabBox = $('#TabBox');
		$TabBox.find('> *').addClass('move');
		if(id){
			$('#'+id).removeClass('move');
			this.scrollMagicWrapper.change(id);
			$TabBox.data('id',id);
			this.tabBtnChange(id);
		} else {
			$('#TabSanpo').removeClass('move');
			this.scrollMagicWrapper.change('TabSanpo');
			$TabBox.data('id','TabSanpo');
			this.tabBtnChange('TabSanpo');
		}
*/
	}
	
	initScPosition(){
	}
		
	initEvent(){
		let navToggleFunc = ()=>{
			if(this.gnav.isOpen){
				this.gnav.close();
				this.btnHamburger.close();
			} else {
				this.gnav.open();				
				this.btnHamburger.open();
			}
		};
		this.btnHamburger.on('click' , navToggleFunc);
	}

}
Zoomin.addIndicators = false;

class ScrollMagicWrapper{
	constructor(top){
		this.top = top;
		this.initScrollMagicCommon();
		this.initScrollMagicZoom();
	}
	
	reset(){
		this.resetScrollMagicZoom();
	}

	initScrollMagicCommon(){
	}
	
	resetScrollMagicZoom(){
		if(this.controllerZoom){
			this.controllerZoom.destroy(true);
			this.controllerZoom = null;			
		}
	}
	
	initScrollMagicZoom(){
		this.controllerZoom = new ScrollMagic.Controller({addIndicators: Zoomin.addIndicators});
		
		let funcZoom = (id , dir , offset=0)=>{
			let translateX;
			let translateY;
			if(dir == 'left'){
				translateX = [0,-20];
				translateY = 0;
			} else if(dir == 'right') {
				translateX = [0,20];
				translateY = 0;
			} else {
				translateX = 0;
				translateY = [0,20];
			}
			
			$(id).find('.ph').velocity('stop').css({opacity:0});
			
			new ScrollMagic.Scene({triggerElement: id , offset : offset})
				.on('enter',(e)=>{
					$(id).find('.ph').velocity('stop').velocity({opacity:1,translateX:translateX,translateY:translateY},{duration:1400,delay:0,easing:'swing'});
				})
				.on('leave',(e)=>{
					$(id).find('.ph').velocity('stop').velocity({opacity:0,translateX:0,translateY:0},{duration:500,delay:0,easing:'swing'});
				})
				.addTo(this.controllerZoom);
		}
		
		let $kumoArr = [];
		let kumoObjArr = [];
		$('#ZoomYukimaru .kumobox div').each((i,v)=>{
			$(v).removeAttr('style');
			$kumoArr[i] = $(v);
			kumoObjArr[i] = {x:i*15,opacity:0,vx:0.3,initx: $(v).position().left };
		});
		let kumoloopflg = false;
		let kumoloop = ()=>{
			requestAnimationFrame(kumoloop.bind(this));
			if(!kumoloopflg) return;
			$kumoArr.forEach((v,i)=>{
				kumoObjArr[i].vx += (0.3 - kumoObjArr[i].vx )*0.05;
				kumoObjArr[i].x += kumoObjArr[i].vx;
				$kumoArr[i].css({
					left : kumoObjArr[i].x + kumoObjArr[i].initx
					,opacity : kumoObjArr[i].opacity
				});

				if( kumoObjArr[i].x > 100){
					kumoObjArr[i].opacity -= 0.01;
					if(kumoObjArr[i].opacity <= 0){
						kumoObjArr[i].x = 0;
					}
				} else {
					if(kumoObjArr[i].opacity < 1){
						kumoObjArr[i].opacity += 0.01;
					} else {
						kumoObjArr[i].opacity = 1;
					}					
				}
			});
		}
		kumoloop();
		new ScrollMagic.Scene({triggerElement: "#ZoomYukimaru", duration: Browser.windowHeight*2 , offset :  -Browser.windowHeight*0.5 })
			.on('progress',(e)=>{
				$kumoArr.forEach((v,i)=>{
					kumoObjArr[i].vx = 1.2;
				});
			})
			.on('enter',(e)=>{
				kumoloopflg = true;
				$kumoArr.forEach((v,i)=>{
					$kumoArr[i].velocity('stop').velocity({scaleX:[0.8,1],scaleY:[0.8,1]},{ duration:3000,loop:true});
				});
				$('#ZoomYukimaru .ph').velocity('stop').velocity({translateY:20}, { duration:1500, loop: true });
			})
			.on('leave',(e)=>{
				kumoloopflg = false;
				$kumoArr.forEach((v,i)=>{
					$kumoArr[i].velocity('stop');
				});
				$('#ZoomYukimaru .ph').velocity('stop').velocity({translateY:0}, { duration:1000 });
			})
			.addTo(this.controllerZoom);
		
		
		funcZoom('#Zoom1','right');
		funcZoom('#Zoom2','left');
		funcZoom('#Zoom3','right');
		funcZoom('#Zoom4','left');
		funcZoom('#Zoom5','bottom',(Browser.responsive == 'sp') ? 0 : 150);
		this.initScrollMagicDecoCircle('#Zoom6' , this.controllerZoom);
		
		new ScrollMagic.Scene({triggerElement: "#Zoom6", duration: $('#Zoom6').height() * 1.5})
			.on('enter',(e)=>{
				$('#Zoom6 .ph1').velocity('stop').velocity({translateY:[15,0]}, { duration:2000, loop: true });
				$('#Zoom6 .ph2').velocity('stop').velocity({translateY:[0,15]}, { duration:2000, loop: true});
			})
			.on('leave',(e)=>{
				$('#Zoom6 .ph1').velocity('stop').velocity({translateY:0}, { duration:1000 });
				$('#Zoom6 .ph2').velocity('stop').velocity({translateY:0}, { duration:1000 });
			})
			.addTo(this.controllerZoom);
			
	}
	
	initScrollMagicDecoCircle(id , controller){
		new ScrollMagic.Scene({triggerElement: id})
			.on('enter',(e)=>{
				$(id).find('.DecoCircle').data('decocircle').open();
			})
			.on('leave',(e)=>{
				$(id).find('.DecoCircle').data('decocircle').close();
			})
			.addTo(controller);
	}
}

export default Zoomin;


// WEBPACK FOOTER //
// ./js/main/zoomin.js